<script setup>
  import { ref, computed } from "vue";
  defineProps({
    closeModal: Function,
  });

  import { useCompanyStore } from "@/stores/company";
  import { useDataCollectionStore } from "@/stores/dataCollection";
  import { useUiStore } from "@/stores/ui";
  const dataCollectionStore = useDataCollectionStore();
  const uiStore = useUiStore();
  const emit = defineEmits(['refresh']);
  const company_id = useCompanyStore().companyId;
  const getModalAction = computed(() => uiStore.modalAction);

  let name = ref(null);
  let description = ref(null);
  let isSubmitted = ref(false);

  const resetStoreData = () => {
    uiStore.resetModalStore();
    name.value = null;
    description.value = null;
    isSubmitted.value = false;
  };

  const onSubmit = async () => {
    isSubmitted.value = true;

    const data = {
      name: name.value,
      description: description.value,
      company_id
    };

    dataCollectionStore.addDataSource(data).then(() => {
      emit('refresh');
      resetStoreData();
    }).catch(() => {
      isSubmitted.value = false;
    });
  }
</script>
<template>
  <DModal v-if="getModalAction === 'add_data_collection'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Add New Collection </template>
    
    <template #body>

        <DInput :value="name" @input="name = $event.target.value" label="Collection Name" width="100%" />

        <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description" maxlength="65"
          id="collectionDescription"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="collectionDescription">Description</label>
      </FloatLabel>

        <!-- <div class="relative"> 
          <span v-if="status" class="multiselect-title-span">Status</span>
          <VMultiselect v-model="status" :options="statusOptions" :disabled="!statusOptions.length" :loading="!statusOptions.length" 
          :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Status" />
        </div> -->

    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="!name || isSubmitted" @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">Add 
            <span v-if="isSubmitted" class="spinner-sm" role="status" aria-hidden="true"></span></button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button"> Cancel </button>
        </div>
      </div>
    </template>

  </DModal>
</template>
